import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdersService } from 'src/app/services/orders.service';
import { BasketsService } from 'src/app/services/baskets.service';
import { ProductsService } from 'src/app/services/products.service';
import { UserService } from 'src/app/services/user.service';
import { MetaService } from 'src/app/services/meta.service';
import { MatSnackBar } from '@angular/material';

import * as moment from 'moment';

@Component({
  selector: 'app-edit-order',
  templateUrl: './edit-order.component.html',
  styleUrls: ['./edit-order.component.css']
})
export class EditOrderComponent implements OnInit {

  baskets = [];
  products = [];
  serviceAgents = [];

  user: any = [];

  editAddress: boolean = false;
  reorderClicked: boolean = false;

  pricing: any = {};

  deliveryDates = {
    deliveryOne: '',
    deliveryOneStatus: '',
    deliveryTwo: '',
    deliveryTwoStatus: '',
    deliveryThree: '',
    deliveryThreeStatus: '',
    deliveryFour: '',
    deliveryFourStatus: ''
  }

  address = {
    addressID: '',
    contactPerson: '',
    mobile: '',
    houseNo: '',
    street: '',
    building: '',
    city: ''
  }

  newAddress = {
    contactPerson: '',
    mobile: '',
    houseNo: '',
    street: '',
    building: '',
    city: ''
  }

  order = {
    baskets: [],
    products: [],
    deliveryDates: [],
    orderType: 'One Delivery',
    mobile: '',
    reorder: false,
    couponCode: '',
    status: ''
  }

  constructor(private basketsService: BasketsService, private productsService: ProductsService, private orderService: OrdersService, private usersService: UserService, private META: MetaService, private snackBar: MatSnackBar, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {

      const data = new FormData();
      data.append('_id', params.id)

      this.orderService.getAnOrder(data).subscribe(result => {
        if (result.success) {
          this.order = {
            baskets: result.data.baskets,
            products: result.data.products,
            deliveryDates: [],
            orderType: result.data.orderType,
            mobile: result.data.mobile,
            reorder: result.data.reorder,
            couponCode: '',
            status: result.data.status
          }

          this.address = {
            addressID: '',
            contactPerson: result.data.contactPerson,
            mobile: result.data.mobile,
            houseNo: result.data.houseNo,
            street: result.data.street,
            building: result.data.building,
            city: result.data.city
          }

          this.pricing = {
            total: result.data.total,
            subtotal: result.data.subtotal,
            fees: result.data.fees,
            oneDeliveryTotal: ''
          }

          if (result.data.orderType == 'Subscription' || result.data.orderType == 'One Delivery') {
            let dates = [];

            result.data.deliveries.map(delivery => {
              const splitDate = delivery.deliveryDate.split('-');

              let status;

              if (delivery.status === 'Pending') {
                status = false
              } else {
                status = true
              }

              const newDate = {
                date: `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`,
                status: status
              };
              dates.push(newDate);
            });

            if (result.data.orderType == 'Subscription') {
              this.deliveryDates.deliveryOne = dates[0].date;
              this.deliveryDates.deliveryTwo = dates[1].date;
              this.deliveryDates.deliveryThree = dates[2].date;
              this.deliveryDates.deliveryFour = dates[3].date;

              this.deliveryDates.deliveryOneStatus = dates[0].status;
              this.deliveryDates.deliveryTwoStatus = dates[1].status;
              this.deliveryDates.deliveryThreeStatus = dates[2].status;
              this.deliveryDates.deliveryFourStatus = dates[3].status;
            } else {
              this.deliveryDates.deliveryOne = dates[0].date;
              this.deliveryDates.deliveryOneStatus = dates[0].status;
            }
          }
        }
      });
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    this.basketsService.getBaskets().subscribe(result => {
      this.baskets = result.data;
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    this.productsService.getProducts().subscribe(result => {
      this.products = result.data;
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    this.route.queryParams.subscribe(params => {
      const data = new FormData();
      data.append('mobile', params.mobile);

      this.usersService.getUsersAdAdmin(data).subscribe(result => {
        if (result.success) {
          this.user = result.data[0];
        }
      }, error => {
        this.snackBar.open(error.error.data, 'Dismiss', {
          duration: 3000
        });
      });
    });
  }

  onAddBasket(ID, Name, Qty) {
    if (Qty == '') {
      this.snackBar.open('Quantity cannot be empty', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    if (Qty == 0) {
      this.snackBar.open('Quantity cannot be 0', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    const data = {
      _id: ID,
      name: Name,
      quantity: Qty
    }
    this.order.baskets.push(data);
    this.calculatePrice();
  }

  onAddProduct(ID, Name, Qty) {
    if (Qty == '') {
      this.snackBar.open('Quantity cannot be empty', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    if (Qty == 0) {
      this.snackBar.open('Quantity cannot be 0', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    const data = {
      _id: ID,
      name: Name,
      quantity: Qty
    }
    this.order.products.push(data);
    this.calculatePrice();
  }

  onRemoveBasket(ID) {
    this.order.baskets = this.order.baskets.filter(product => product._id !== ID);
    this.calculatePrice();
  }

  onRemoveProduct(ID) {
    this.order.products = this.order.products.filter(product => product._id !== ID);
    this.calculatePrice();
  }

  onReorder(event) {
    this.reorderClicked = true;
  }

  onUpdateOrder() {

    const validator = this.validations();
    if (validator === null) {
      return;
    }

    if (this.order.orderType === 'One Delivery' && this.deliveryDates.deliveryOne !== '') {
      this.order.deliveryDates = [moment(this.deliveryDates.deliveryOne).format('DD-MM-YYYY').toString()];
    }

    if (this.order.orderType === 'Subscription' && (this.deliveryDates.deliveryOne !== '' || this.deliveryDates.deliveryTwo !== '' || this.deliveryDates.deliveryThree !== '' || this.deliveryDates.deliveryFour !== '')) {

      let dates = [
        { date: this.deliveryDates.deliveryOne, status: this.deliveryDates.deliveryOneStatus },
        { date: this.deliveryDates.deliveryTwo, status: this.deliveryDates.deliveryTwoStatus },
        { date: this.deliveryDates.deliveryThree, status: this.deliveryDates.deliveryThreeStatus },
        { date: this.deliveryDates.deliveryFour, status: this.deliveryDates.deliveryFourStatus }
      ]

      dates.map(delivery => {
        if (!delivery.status) {
          this.order.deliveryDates.push(moment(delivery.date).format('DD-MM-YYYY').toString(),)
        }
      });
    }

    let baskets = [];
    let products = [];

    if (this.order.baskets.length != 0) {
      this.order.baskets.map(basket => {
        const updatedBasket = {
          _id: basket._id,
          quantity: basket.quantity
        }
        baskets.push(updatedBasket);
      });
    }

    if (this.order.products.length != 0) {
      this.order.products.map(product => {
        const updatedProducts = {
          _id: product._id,
          quantity: product.quantity
        }
        products.push(updatedProducts);
      });
    }

    const data = new FormData();

    data.append('baskets', JSON.stringify(baskets));
    data.append('products', JSON.stringify(products));
    data.append('deliveryDates', JSON.stringify(this.order.deliveryDates));

    if (this.reorderClicked) {
      data.append('reorder', 'false');
    }

    if (this.editAddress && this.address.addressID !== '') {
      data.append('addressID', this.address.addressID);

    } else if (this.editAddress && this.address.addressID == '') {
      this.newAddress.mobile = this.order.mobile;
      if (this.newAddress.building == '') {
        this.newAddress.building = '-';
      }
      data.append('address', JSON.stringify(this.newAddress));
    }

    this.route.queryParams.subscribe(params => {
      data.append('order', params.id);
    });

    if (this.order.status == 'Paused') {
      data.append('status', 'Pending');
    }

    this.orderService.updateOrderAsAdmin(data).subscribe(result => {
      if (result.success) {
        this.router.navigate(['/admin/users/orders/'], { queryParams: { mobile: this.order.mobile } });
        this.snackBar.open('Order updated successfully', 'Dismiss', {
          duration: 3000
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onOrderTypeChange() {
    this.calculatePrice();
  }


  onAddCouponCode() {
    this.calculatePrice();
  }

  calculatePrice() {
    const data = new FormData()

    let baskets = [];
    let products = [];

    if (this.order.baskets.length != 0) {
      this.order.baskets.map(basket => {
        const updatedBasket = {
          _id: basket._id,
          quantity: basket.quantity
        }
        baskets.push(updatedBasket);
      });
    }

    if (this.order.products.length != 0) {
      this.order.products.map(product => {
        const updatedProducts = {
          _id: product._id,
          quantity: product.quantity
        }
        products.push(updatedProducts);
      });
    }

    data.append('baskets', JSON.stringify(baskets));
    data.append('products', JSON.stringify(products));
    data.append('mobile', this.order.mobile);
    data.append('orderType', this.order.orderType);

    if (this.order.couponCode !== '') {
      data.append('couponCode', this.order.couponCode);
    }

    this.orderService.calculatePriceAsAdmin(data).subscribe(result => {
      if (result.success) {
        this.pricing = result.data;
      }
    }, error => {
      this.pricing = error.error.data;
    });
  }

  onEnableEditing() {
    this.editAddress = true;
  }

  onDisableEditing() {
    this.editAddress = false;
    this.newAddress = {
      contactPerson: '',
      mobile: '',
      houseNo: '',
      street: '',
      building: '',
      city: ''
    };
    this.address.addressID = '';
  }

  validations(): string {

    if (this.order.orderType === 'One Delivery' && this.deliveryDates.deliveryOne === '') {
      this.snackBar.open('Delivery date cannot be empty', 'Dismiss', {
        duration: 3000
      });
      return null;
    }

    if (this.order.orderType === 'Subscription' && (this.deliveryDates.deliveryOne === '' || this.deliveryDates.deliveryTwo === '' || this.deliveryDates.deliveryThree === '' || this.deliveryDates.deliveryFour === '')) {
      this.snackBar.open('Please select all four delivery dates', 'Dismiss', {
        duration: 3000
      });
      return null;
    }

    if (this.order.orderType == '') {
      this.snackBar.open('Order type cannot be none or empty', 'Dismiss', {
        duration: 3000
      });
      return null;
    }

    if (this.editAddress && this.address.addressID !== '' && (this.newAddress.contactPerson !== '' || this.newAddress.houseNo !== '' || this.newAddress.street !== '' || this.newAddress.building !== '' || this.newAddress.city !== '')) {
      this.snackBar.open('You cannot have both a new address and an existing address selected', 'Dismiss', {
        duration: 3000
      });
      return null;
    }

    if (this.editAddress && this.address.addressID == '' && this.newAddress.contactPerson == '' && this.newAddress.houseNo == '' && this.newAddress.street == '' && this.newAddress.building == '' && this.newAddress.city == '') {
      this.snackBar.open('Please select an address or enter a new address', 'Dismiss', {
        duration: 3000
      });
      return null;
    }
  }

  onDelete() {
    this.route.queryParams.subscribe(params => {
      const data = new FormData();
      data.append('_id', params.id)

      this.orderService.deleterderAsAdmin(data).subscribe(result => {
        if (result.success) {
          this.router.navigate(['/admin/users/orders/'], { queryParams: { mobile: this.order.mobile } });
          this.snackBar.open('Order deleted successfully', 'Dismiss', {
            duration: 3000
          });
        }
      }, error => {
        this.snackBar.open(error.error.data, 'Dismiss', {
          duration: 3000
        });
      });
    });
  }

  onPause() {
    this.route.queryParams.subscribe(params => {
      const data = new FormData();
      data.append('_id', params.id)

      this.orderService.pauseOrderAsAdmin(data).subscribe(result => {
        if (result.success) {
          this.router.navigate(['/admin/users/orders/'], { queryParams: { mobile: this.order.mobile } });
          this.snackBar.open('Order paused successfully', 'Dismiss', {
            duration: 3000
          });
        }
      }, error => {
        this.snackBar.open(error.error.data, 'Dismiss', {
          duration: 3000
        });
      });
    });
  }
}